export default "__VITE_ASSET__MPIX0O9K__"